export default __webpack_public_path__ + "static/media/banner_modal-portalx2.1a78914b.jpg";